/**
 * Campus Framework API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@bitapp.it
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpParameterCodec }       from '@angular/common/http';
import { CustomHttpParameterCodec }                          from '../encoder';
import { Observable }                                        from 'rxjs';

import { CourseType } from '../model/models';
import { GlimpseResponse } from '../model/models';
import { LastUpdateDateResponse } from '../model/models';
import { ReportCertificationCode } from '../model/models';
import { ReportCertificationMifidDisciplinesResponse } from '../model/models';
import { ReportCertificationResponse } from '../model/models';
import { ReportCourseStatus } from '../model/models';
import { ReportCourseType } from '../model/models';
import { ReportCoursesResponse } from '../model/models';
import { ReportEditionstatus } from '../model/models';
import { ReportProductSheetsResponse } from '../model/models';
import { ReportSatisfactionQuizzesResponse } from '../model/models';
import { ReportUserCourseEditionDaysResponse } from '../model/models';
import { ReportUserCourseEditionResponse } from '../model/models';
import { ReportUserCourseEditionsResponse } from '../model/models';
import { ReportUserCourseResponse } from '../model/models';
import { ReportUserMulticourseCoursesResponse } from '../model/models';
import { ReportUserMulticourseResponse } from '../model/models';
import { SatisfactionQuizDetailsResponse } from '../model/models';
import { User } from '../model/models';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';



@Injectable({
  providedIn: 'root'
})
export class ReportsService {

    protected basePath = 'https://api.campusframework.test';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();
    public encoder: HttpParameterCodec;

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (configuration) {
            this.configuration = configuration;
        }
        if (typeof this.configuration.basePath !== 'string') {
            if (typeof basePath !== 'string') {
                basePath = this.basePath;
            }
            this.configuration.basePath = basePath;
        }
        this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
    }


    private addToHttpParams(httpParams: HttpParams, value: any, key?: string): HttpParams {
        if (typeof value === "object" && value instanceof Date === false) {
            httpParams = this.addToHttpParamsRecursive(httpParams, value);
        } else {
            httpParams = this.addToHttpParamsRecursive(httpParams, value, key);
        }
        return httpParams;
    }

    private addToHttpParamsRecursive(httpParams: HttpParams, value?: any, key?: string): HttpParams {
        if (value == null) {
            return httpParams;
        }

        if (typeof value === "object") {
            if (Array.isArray(value)) {
                (value as any[]).forEach( elem => httpParams = this.addToHttpParamsRecursive(httpParams, elem, key));
            } else if (value instanceof Date) {
                if (key != null) {
                    httpParams = httpParams.append(key,
                        (value as Date).toISOString().substr(0, 10));
                } else {
                   throw Error("key may not be null if value is Date");
                }
            } else {
                Object.keys(value).forEach( k => httpParams = this.addToHttpParamsRecursive(
                    httpParams, value[k], key != null ? `${key}.${k}` : k));
            }
        } else if (key != null) {
            httpParams = httpParams.append(key, value);
        } else {
            throw Error("key may not be null if value is not object or array");
        }
        return httpParams;
    }

    /**
     * Get etl courses
     * @param autocomplete filter by name
     * @param courseTypes filter by course types
     * @param path filter by path
     * @param productCodeName filter by product code or name
     * @param subproductLineCodeName filter by subproduct code or name or line code or name
     * @param isinCode filter by isin code
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public autocompleteCourses(autocomplete?: string, courseTypes?: Array<ReportCourseType>, path?: number, productCodeName?: string, subproductLineCodeName?: string, isinCode?: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<GlimpseResponse>;
    public autocompleteCourses(autocomplete?: string, courseTypes?: Array<ReportCourseType>, path?: number, productCodeName?: string, subproductLineCodeName?: string, isinCode?: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<GlimpseResponse>>;
    public autocompleteCourses(autocomplete?: string, courseTypes?: Array<ReportCourseType>, path?: number, productCodeName?: string, subproductLineCodeName?: string, isinCode?: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<GlimpseResponse>>;
    public autocompleteCourses(autocomplete?: string, courseTypes?: Array<ReportCourseType>, path?: number, productCodeName?: string, subproductLineCodeName?: string, isinCode?: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {

        let queryParameters = new HttpParams({encoder: this.encoder});
        if (autocomplete !== undefined && autocomplete !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>autocomplete, 'autocomplete');
        }
        if (courseTypes) {
            courseTypes.forEach((element) => {
                queryParameters = this.addToHttpParams(queryParameters,
                  <any>element, 'course_types[]');
            })
        }
        if (path !== undefined && path !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>path, 'path');
        }
        if (productCodeName !== undefined && productCodeName !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>productCodeName, 'product_code_name');
        }
        if (subproductLineCodeName !== undefined && subproductLineCodeName !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>subproductLineCodeName, 'subproduct_line_code_name');
        }
        if (isinCode !== undefined && isinCode !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>isinCode, 'isin_code');
        }

        let headers = this.defaultHeaders;

        let credential: string | undefined;
        // authentication (oauth) required
        credential = this.configuration.lookupCredential('oauth');
        if (credential) {
            headers = headers.set('Authorization', 'Bearer ' + credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.get<GlimpseResponse>(`${this.configuration.basePath}/reports/autocomplete/courses`,
            {
                params: queryParameters,
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get etl paths
     * @param autocomplete filter by name
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public autocompletePaths(autocomplete?: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<GlimpseResponse>;
    public autocompletePaths(autocomplete?: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<GlimpseResponse>>;
    public autocompletePaths(autocomplete?: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<GlimpseResponse>>;
    public autocompletePaths(autocomplete?: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {

        let queryParameters = new HttpParams({encoder: this.encoder});
        if (autocomplete !== undefined && autocomplete !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>autocomplete, 'autocomplete');
        }

        let headers = this.defaultHeaders;

        let credential: string | undefined;
        // authentication (oauth) required
        credential = this.configuration.lookupCredential('oauth');
        if (credential) {
            headers = headers.set('Authorization', 'Bearer ' + credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.get<GlimpseResponse>(`${this.configuration.basePath}/reports/autocomplete/paths`,
            {
                params: queryParameters,
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get etl users
     * @param autocomplete filter by name
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public autocompleteUsers(autocomplete?: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<GlimpseResponse>;
    public autocompleteUsers(autocomplete?: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<GlimpseResponse>>;
    public autocompleteUsers(autocomplete?: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<GlimpseResponse>>;
    public autocompleteUsers(autocomplete?: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {

        let queryParameters = new HttpParams({encoder: this.encoder});
        if (autocomplete !== undefined && autocomplete !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>autocomplete, 'autocomplete');
        }

        let headers = this.defaultHeaders;

        let credential: string | undefined;
        // authentication (oauth) required
        credential = this.configuration.lookupCredential('oauth');
        if (credential) {
            headers = headers.set('Authorization', 'Bearer ' + credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.get<GlimpseResponse>(`${this.configuration.basePath}/reports/autocomplete/users`,
            {
                params: queryParameters,
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * export all report of certification consulente patrimoniale
     * @param page The page to load
     * @param certification filter by certification
     * @param user filter by user
     * @param position filter by position
     * @param segment filter by segment
     * @param manager filter by managers
     * @param network filter by network
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public exportReportCertificationCp(page?: number, certification?: number, user?: number, position?: string, segment?: string, manager?: number, network?: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'}): Observable<Blob>;
    public exportReportCertificationCp(page?: number, certification?: number, user?: number, position?: string, segment?: string, manager?: number, network?: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'}): Observable<HttpResponse<Blob>>;
    public exportReportCertificationCp(page?: number, certification?: number, user?: number, position?: string, segment?: string, manager?: number, network?: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'}): Observable<HttpEvent<Blob>>;
    public exportReportCertificationCp(page?: number, certification?: number, user?: number, position?: string, segment?: string, manager?: number, network?: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'}): Observable<any> {

        let queryParameters = new HttpParams({encoder: this.encoder});
        if (page !== undefined && page !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>page, 'page');
        }
        if (certification !== undefined && certification !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>certification, 'certification');
        }
        if (user !== undefined && user !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>user, 'user');
        }
        if (position !== undefined && position !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>position, 'position');
        }
        if (segment !== undefined && segment !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>segment, 'segment');
        }
        if (manager !== undefined && manager !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>manager, 'manager');
        }
        if (network !== undefined && network !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>network, 'network');
        }

        let headers = this.defaultHeaders;

        let credential: string | undefined;
        // authentication (oauth) required
        credential = this.configuration.lookupCredential('oauth');
        if (credential) {
            headers = headers.set('Authorization', 'Bearer ' + credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        return this.httpClient.get(`${this.configuration.basePath}/reports/certifications/cp/export`,
            {
                params: queryParameters,
                responseType: "blob",
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Export all report of certification ivass
     * @param page The page to load
     * @param certification filter by certification
     * @param user filter by user
     * @param position filter by position
     * @param segment filter by segment
     * @param manager filter by managers
     * @param network filter by network
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public exportReportCertificationIvass(page?: number, certification?: number, user?: number, position?: string, segment?: string, manager?: number, network?: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'}): Observable<Blob>;
    public exportReportCertificationIvass(page?: number, certification?: number, user?: number, position?: string, segment?: string, manager?: number, network?: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'}): Observable<HttpResponse<Blob>>;
    public exportReportCertificationIvass(page?: number, certification?: number, user?: number, position?: string, segment?: string, manager?: number, network?: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'}): Observable<HttpEvent<Blob>>;
    public exportReportCertificationIvass(page?: number, certification?: number, user?: number, position?: string, segment?: string, manager?: number, network?: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'}): Observable<any> {

        let queryParameters = new HttpParams({encoder: this.encoder});
        if (page !== undefined && page !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>page, 'page');
        }
        if (certification !== undefined && certification !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>certification, 'certification');
        }
        if (user !== undefined && user !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>user, 'user');
        }
        if (position !== undefined && position !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>position, 'position');
        }
        if (segment !== undefined && segment !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>segment, 'segment');
        }
        if (manager !== undefined && manager !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>manager, 'manager');
        }
        if (network !== undefined && network !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>network, 'network');
        }

        let headers = this.defaultHeaders;

        let credential: string | undefined;
        // authentication (oauth) required
        credential = this.configuration.lookupCredential('oauth');
        if (credential) {
            headers = headers.set('Authorization', 'Bearer ' + credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        return this.httpClient.get(`${this.configuration.basePath}/reports/certifications/ivass/export`,
            {
                params: queryParameters,
                responseType: "blob",
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Export all report of certification MIFID
     * @param page The page to load
     * @param certification filter by certification
     * @param user filter by user
     * @param position filter by position
     * @param segment filter by segment
     * @param manager filter by managers
     * @param network filter by network
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public exportReportCertificationMifid(page?: number, certification?: number, user?: number, position?: string, segment?: string, manager?: number, network?: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'}): Observable<Blob>;
    public exportReportCertificationMifid(page?: number, certification?: number, user?: number, position?: string, segment?: string, manager?: number, network?: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'}): Observable<HttpResponse<Blob>>;
    public exportReportCertificationMifid(page?: number, certification?: number, user?: number, position?: string, segment?: string, manager?: number, network?: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'}): Observable<HttpEvent<Blob>>;
    public exportReportCertificationMifid(page?: number, certification?: number, user?: number, position?: string, segment?: string, manager?: number, network?: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'}): Observable<any> {

        let queryParameters = new HttpParams({encoder: this.encoder});
        if (page !== undefined && page !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>page, 'page');
        }
        if (certification !== undefined && certification !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>certification, 'certification');
        }
        if (user !== undefined && user !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>user, 'user');
        }
        if (position !== undefined && position !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>position, 'position');
        }
        if (segment !== undefined && segment !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>segment, 'segment');
        }
        if (manager !== undefined && manager !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>manager, 'manager');
        }
        if (network !== undefined && network !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>network, 'network');
        }

        let headers = this.defaultHeaders;

        let credential: string | undefined;
        // authentication (oauth) required
        credential = this.configuration.lookupCredential('oauth');
        if (credential) {
            headers = headers.set('Authorization', 'Bearer ' + credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        return this.httpClient.get(`${this.configuration.basePath}/reports/certifications/mifid/export`,
            {
                params: queryParameters,
                responseType: "blob",
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Export report of courses
     * @param type filter by type
     * @param course filter by course
     * @param path filter by path
     * @param year filter by year
     * @param status filter by status
     * @param user filter by user
     * @param position filter by position
     * @param segment filter by segment
     * @param manager filter by managers
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public exportReportCourses(type?: CourseType, course?: string, path?: number, year?: number, status?: ReportCourseStatus, user?: number, position?: string, segment?: string, manager?: User, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'}): Observable<Blob>;
    public exportReportCourses(type?: CourseType, course?: string, path?: number, year?: number, status?: ReportCourseStatus, user?: number, position?: string, segment?: string, manager?: User, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'}): Observable<HttpResponse<Blob>>;
    public exportReportCourses(type?: CourseType, course?: string, path?: number, year?: number, status?: ReportCourseStatus, user?: number, position?: string, segment?: string, manager?: User, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'}): Observable<HttpEvent<Blob>>;
    public exportReportCourses(type?: CourseType, course?: string, path?: number, year?: number, status?: ReportCourseStatus, user?: number, position?: string, segment?: string, manager?: User, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'}): Observable<any> {

        let queryParameters = new HttpParams({encoder: this.encoder});
        if (type !== undefined && type !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>type, 'type');
        }
        if (course !== undefined && course !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>course, 'course');
        }
        if (path !== undefined && path !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>path, 'path');
        }
        if (year !== undefined && year !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>year, 'year');
        }
        if (status !== undefined && status !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>status, 'status');
        }
        if (user !== undefined && user !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>user, 'user');
        }
        if (position !== undefined && position !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>position, 'position');
        }
        if (segment !== undefined && segment !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>segment, 'segment');
        }
        if (manager !== undefined && manager !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>manager, 'manager');
        }

        let headers = this.defaultHeaders;

        let credential: string | undefined;
        // authentication (oauth) required
        credential = this.configuration.lookupCredential('oauth');
        if (credential) {
            headers = headers.set('Authorization', 'Bearer ' + credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        return this.httpClient.get(`${this.configuration.basePath}/reports/courses/export`,
            {
                params: queryParameters,
                responseType: "blob",
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Export report product sheets
     * @param manager filter by manager
     * @param startsAt filter by starts_at
     * @param endsAt filter by ends_at
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public exportReportProductSheets(manager?: User, startsAt?: string, endsAt?: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'}): Observable<Blob>;
    public exportReportProductSheets(manager?: User, startsAt?: string, endsAt?: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'}): Observable<HttpResponse<Blob>>;
    public exportReportProductSheets(manager?: User, startsAt?: string, endsAt?: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'}): Observable<HttpEvent<Blob>>;
    public exportReportProductSheets(manager?: User, startsAt?: string, endsAt?: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'}): Observable<any> {

        let queryParameters = new HttpParams({encoder: this.encoder});
        if (manager !== undefined && manager !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>manager, 'manager');
        }
        if (startsAt !== undefined && startsAt !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>startsAt, 'starts_at');
        }
        if (endsAt !== undefined && endsAt !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>endsAt, 'ends_at');
        }

        let headers = this.defaultHeaders;

        let credential: string | undefined;
        // authentication (oauth) required
        credential = this.configuration.lookupCredential('oauth');
        if (credential) {
            headers = headers.set('Authorization', 'Bearer ' + credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        return this.httpClient.get(`${this.configuration.basePath}/reports/product-sheets/export`,
            {
                params: queryParameters,
                responseType: "blob",
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get all report of satisfaction quizzes
     * @param page The page to load
     * @param startsAt filter by starts_at
     * @param endsAt filter by ends_at
     * @param course filter by course
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public exportReportSatisfactionQuizzes(page?: number, startsAt?: string, endsAt?: string, course?: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'}): Observable<Blob>;
    public exportReportSatisfactionQuizzes(page?: number, startsAt?: string, endsAt?: string, course?: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'}): Observable<HttpResponse<Blob>>;
    public exportReportSatisfactionQuizzes(page?: number, startsAt?: string, endsAt?: string, course?: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'}): Observable<HttpEvent<Blob>>;
    public exportReportSatisfactionQuizzes(page?: number, startsAt?: string, endsAt?: string, course?: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'}): Observable<any> {

        let queryParameters = new HttpParams({encoder: this.encoder});
        if (page !== undefined && page !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>page, 'page');
        }
        if (startsAt !== undefined && startsAt !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>startsAt, 'starts_at');
        }
        if (endsAt !== undefined && endsAt !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>endsAt, 'ends_at');
        }
        if (course !== undefined && course !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>course, 'course');
        }

        let headers = this.defaultHeaders;

        let credential: string | undefined;
        // authentication (oauth) required
        credential = this.configuration.lookupCredential('oauth');
        if (credential) {
            headers = headers.set('Authorization', 'Bearer ' + credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        return this.httpClient.get(`${this.configuration.basePath}/reports/satisafction-quizzes/export`,
            {
                params: queryParameters,
                responseType: "blob",
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Export days of a specific user course report
     * @param userId The id of the user
     * @param courseId The id of the course
     * @param editionId The id of the edition
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public exportReportUserCourseEditionDays(userId: number, courseId: string, editionId: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'}): Observable<Blob>;
    public exportReportUserCourseEditionDays(userId: number, courseId: string, editionId: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'}): Observable<HttpResponse<Blob>>;
    public exportReportUserCourseEditionDays(userId: number, courseId: string, editionId: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'}): Observable<HttpEvent<Blob>>;
    public exportReportUserCourseEditionDays(userId: number, courseId: string, editionId: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'}): Observable<any> {
        if (userId === null || userId === undefined) {
            throw new Error('Required parameter userId was null or undefined when calling exportReportUserCourseEditionDays.');
        }
        if (courseId === null || courseId === undefined) {
            throw new Error('Required parameter courseId was null or undefined when calling exportReportUserCourseEditionDays.');
        }
        if (editionId === null || editionId === undefined) {
            throw new Error('Required parameter editionId was null or undefined when calling exportReportUserCourseEditionDays.');
        }

        let headers = this.defaultHeaders;

        let credential: string | undefined;
        // authentication (oauth) required
        credential = this.configuration.lookupCredential('oauth');
        if (credential) {
            headers = headers.set('Authorization', 'Bearer ' + credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        return this.httpClient.get(`${this.configuration.basePath}/reports/courses/${encodeURIComponent(String(userId))}/courses/${encodeURIComponent(String(courseId))}/editions/${encodeURIComponent(String(editionId))}/days/export`,
            {
                responseType: "blob",
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Export editions of a specific user course report
     * @param userId The id of the user
     * @param courseId The id of the course
     * @param year filter by year
     * @param status filter by status
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public exportReportUserCourseEditions(userId: number, courseId: string, year?: number, status?: ReportEditionstatus, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'}): Observable<Blob>;
    public exportReportUserCourseEditions(userId: number, courseId: string, year?: number, status?: ReportEditionstatus, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'}): Observable<HttpResponse<Blob>>;
    public exportReportUserCourseEditions(userId: number, courseId: string, year?: number, status?: ReportEditionstatus, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'}): Observable<HttpEvent<Blob>>;
    public exportReportUserCourseEditions(userId: number, courseId: string, year?: number, status?: ReportEditionstatus, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'}): Observable<any> {
        if (userId === null || userId === undefined) {
            throw new Error('Required parameter userId was null or undefined when calling exportReportUserCourseEditions.');
        }
        if (courseId === null || courseId === undefined) {
            throw new Error('Required parameter courseId was null or undefined when calling exportReportUserCourseEditions.');
        }

        let queryParameters = new HttpParams({encoder: this.encoder});
        if (year !== undefined && year !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>year, 'year');
        }
        if (status !== undefined && status !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>status, 'status');
        }

        let headers = this.defaultHeaders;

        let credential: string | undefined;
        // authentication (oauth) required
        credential = this.configuration.lookupCredential('oauth');
        if (credential) {
            headers = headers.set('Authorization', 'Bearer ' + credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        return this.httpClient.get(`${this.configuration.basePath}/reports/courses/${encodeURIComponent(String(userId))}/courses/${encodeURIComponent(String(courseId))}/editions/export`,
            {
                params: queryParameters,
                responseType: "blob",
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get last update date
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getLastUpdateDate(observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<LastUpdateDateResponse>;
    public getLastUpdateDate(observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<LastUpdateDateResponse>>;
    public getLastUpdateDate(observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<LastUpdateDateResponse>>;
    public getLastUpdateDate(observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {

        let headers = this.defaultHeaders;

        let credential: string | undefined;
        // authentication (oauth) required
        credential = this.configuration.lookupCredential('oauth');
        if (credential) {
            headers = headers.set('Authorization', 'Bearer ' + credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.get<LastUpdateDateResponse>(`${this.configuration.basePath}/reports/last-update-date`,
            {
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get all report of certification certificazione patrimoniale
     * @param page The page to load
     * @param certification filter by certification
     * @param user filter by user
     * @param position filter by position
     * @param segment filter by segment
     * @param manager filter by managers
     * @param network filter by network
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getReportCertificationCp(page?: number, certification?: number, user?: number, position?: string, segment?: string, manager?: number, network?: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<ReportCertificationResponse>;
    public getReportCertificationCp(page?: number, certification?: number, user?: number, position?: string, segment?: string, manager?: number, network?: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<ReportCertificationResponse>>;
    public getReportCertificationCp(page?: number, certification?: number, user?: number, position?: string, segment?: string, manager?: number, network?: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<ReportCertificationResponse>>;
    public getReportCertificationCp(page?: number, certification?: number, user?: number, position?: string, segment?: string, manager?: number, network?: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {

        let queryParameters = new HttpParams({encoder: this.encoder});
        if (page !== undefined && page !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>page, 'page');
        }
        if (certification !== undefined && certification !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>certification, 'certification');
        }
        if (user !== undefined && user !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>user, 'user');
        }
        if (position !== undefined && position !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>position, 'position');
        }
        if (segment !== undefined && segment !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>segment, 'segment');
        }
        if (manager !== undefined && manager !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>manager, 'manager');
        }
        if (network !== undefined && network !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>network, 'network');
        }

        let headers = this.defaultHeaders;

        let credential: string | undefined;
        // authentication (oauth) required
        credential = this.configuration.lookupCredential('oauth');
        if (credential) {
            headers = headers.set('Authorization', 'Bearer ' + credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.get<ReportCertificationResponse>(`${this.configuration.basePath}/reports/certifications/cp`,
            {
                params: queryParameters,
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get all report of certification IVASS
     * @param page The page to load
     * @param certification filter by certification
     * @param user filter by user
     * @param position filter by position
     * @param segment filter by segment
     * @param manager filter by managers
     * @param network filter by network
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getReportCertificationIvass(page?: number, certification?: number, user?: number, position?: string, segment?: string, manager?: number, network?: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<ReportCertificationResponse>;
    public getReportCertificationIvass(page?: number, certification?: number, user?: number, position?: string, segment?: string, manager?: number, network?: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<ReportCertificationResponse>>;
    public getReportCertificationIvass(page?: number, certification?: number, user?: number, position?: string, segment?: string, manager?: number, network?: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<ReportCertificationResponse>>;
    public getReportCertificationIvass(page?: number, certification?: number, user?: number, position?: string, segment?: string, manager?: number, network?: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {

        let queryParameters = new HttpParams({encoder: this.encoder});
        if (page !== undefined && page !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>page, 'page');
        }
        if (certification !== undefined && certification !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>certification, 'certification');
        }
        if (user !== undefined && user !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>user, 'user');
        }
        if (position !== undefined && position !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>position, 'position');
        }
        if (segment !== undefined && segment !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>segment, 'segment');
        }
        if (manager !== undefined && manager !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>manager, 'manager');
        }
        if (network !== undefined && network !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>network, 'network');
        }

        let headers = this.defaultHeaders;

        let credential: string | undefined;
        // authentication (oauth) required
        credential = this.configuration.lookupCredential('oauth');
        if (credential) {
            headers = headers.set('Authorization', 'Bearer ' + credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.get<ReportCertificationResponse>(`${this.configuration.basePath}/reports/certifications/ivass`,
            {
                params: queryParameters,
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get all report of certification MIFID
     * @param page The page to load
     * @param certification filter by certification
     * @param user filter by user
     * @param position filter by position
     * @param segment filter by segment
     * @param manager filter by managers
     * @param network filter by network
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getReportCertificationMifid(page?: number, certification?: number, user?: number, position?: string, segment?: string, manager?: number, network?: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<ReportCertificationResponse>;
    public getReportCertificationMifid(page?: number, certification?: number, user?: number, position?: string, segment?: string, manager?: number, network?: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<ReportCertificationResponse>>;
    public getReportCertificationMifid(page?: number, certification?: number, user?: number, position?: string, segment?: string, manager?: number, network?: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<ReportCertificationResponse>>;
    public getReportCertificationMifid(page?: number, certification?: number, user?: number, position?: string, segment?: string, manager?: number, network?: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {

        let queryParameters = new HttpParams({encoder: this.encoder});
        if (page !== undefined && page !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>page, 'page');
        }
        if (certification !== undefined && certification !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>certification, 'certification');
        }
        if (user !== undefined && user !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>user, 'user');
        }
        if (position !== undefined && position !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>position, 'position');
        }
        if (segment !== undefined && segment !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>segment, 'segment');
        }
        if (manager !== undefined && manager !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>manager, 'manager');
        }
        if (network !== undefined && network !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>network, 'network');
        }

        let headers = this.defaultHeaders;

        let credential: string | undefined;
        // authentication (oauth) required
        credential = this.configuration.lookupCredential('oauth');
        if (credential) {
            headers = headers.set('Authorization', 'Bearer ' + credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.get<ReportCertificationResponse>(`${this.configuration.basePath}/reports/certifications/mifid`,
            {
                params: queryParameters,
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get all disciplines of certification MIFID with completion percentage for a user
     * @param externalTestId The id of the external test
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getReportCertificationMifidDisciplines(externalTestId: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<ReportCertificationMifidDisciplinesResponse>;
    public getReportCertificationMifidDisciplines(externalTestId: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<ReportCertificationMifidDisciplinesResponse>>;
    public getReportCertificationMifidDisciplines(externalTestId: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<ReportCertificationMifidDisciplinesResponse>>;
    public getReportCertificationMifidDisciplines(externalTestId: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
        if (externalTestId === null || externalTestId === undefined) {
            throw new Error('Required parameter externalTestId was null or undefined when calling getReportCertificationMifidDisciplines.');
        }

        let headers = this.defaultHeaders;

        let credential: string | undefined;
        // authentication (oauth) required
        credential = this.configuration.lookupCredential('oauth');
        if (credential) {
            headers = headers.set('Authorization', 'Bearer ' + credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.get<ReportCertificationMifidDisciplinesResponse>(`${this.configuration.basePath}/reports/certifications/mifid/${encodeURIComponent(String(externalTestId))}/disciplines`,
            {
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get all report of courses
     * @param page The page to load
     * @param type filter by type
     * @param course filter by course
     * @param year filter by year
     * @param completionStatus filter by status
     * @param user filter by user
     * @param network filter by network
     * @param position filter by position
     * @param segment filter by segment
     * @param manager filter by manager
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getReportCourses(page?: number, type?: ReportCourseType, course?: string, year?: number, completionStatus?: ReportCourseStatus, user?: number, network?: string, position?: string, segment?: string, manager?: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<ReportCoursesResponse>;
    public getReportCourses(page?: number, type?: ReportCourseType, course?: string, year?: number, completionStatus?: ReportCourseStatus, user?: number, network?: string, position?: string, segment?: string, manager?: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<ReportCoursesResponse>>;
    public getReportCourses(page?: number, type?: ReportCourseType, course?: string, year?: number, completionStatus?: ReportCourseStatus, user?: number, network?: string, position?: string, segment?: string, manager?: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<ReportCoursesResponse>>;
    public getReportCourses(page?: number, type?: ReportCourseType, course?: string, year?: number, completionStatus?: ReportCourseStatus, user?: number, network?: string, position?: string, segment?: string, manager?: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {

        let queryParameters = new HttpParams({encoder: this.encoder});
        if (page !== undefined && page !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>page, 'page');
        }
        if (type !== undefined && type !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>type, 'type');
        }
        if (course !== undefined && course !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>course, 'course');
        }
        if (year !== undefined && year !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>year, 'year');
        }
        if (completionStatus !== undefined && completionStatus !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>completionStatus, 'completion_status');
        }
        if (user !== undefined && user !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>user, 'user');
        }
        if (network !== undefined && network !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>network, 'network');
        }
        if (position !== undefined && position !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>position, 'position');
        }
        if (segment !== undefined && segment !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>segment, 'segment');
        }
        if (manager !== undefined && manager !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>manager, 'manager');
        }

        let headers = this.defaultHeaders;

        let credential: string | undefined;
        // authentication (oauth) required
        credential = this.configuration.lookupCredential('oauth');
        if (credential) {
            headers = headers.set('Authorization', 'Bearer ' + credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.get<ReportCoursesResponse>(`${this.configuration.basePath}/reports/courses`,
            {
                params: queryParameters,
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get all report of product sheets
     * @param page The page to load
     * @param user filter by user
     * @param startsAt filter by starts_at
     * @param endsAt filter by ends_at
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getReportProductSheets(page?: number, user?: number, startsAt?: string, endsAt?: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<ReportProductSheetsResponse>;
    public getReportProductSheets(page?: number, user?: number, startsAt?: string, endsAt?: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<ReportProductSheetsResponse>>;
    public getReportProductSheets(page?: number, user?: number, startsAt?: string, endsAt?: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<ReportProductSheetsResponse>>;
    public getReportProductSheets(page?: number, user?: number, startsAt?: string, endsAt?: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {

        let queryParameters = new HttpParams({encoder: this.encoder});
        if (page !== undefined && page !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>page, 'page');
        }
        if (user !== undefined && user !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>user, 'user');
        }
        if (startsAt !== undefined && startsAt !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>startsAt, 'starts_at');
        }
        if (endsAt !== undefined && endsAt !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>endsAt, 'ends_at');
        }

        let headers = this.defaultHeaders;

        let credential: string | undefined;
        // authentication (oauth) required
        credential = this.configuration.lookupCredential('oauth');
        if (credential) {
            headers = headers.set('Authorization', 'Bearer ' + credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.get<ReportProductSheetsResponse>(`${this.configuration.basePath}/reports/product-sheets`,
            {
                params: queryParameters,
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get satisfaction quiz details
     * @param satisfactionQuizId The id of the satisfaction quiz
     * @param type Type of the entity
     * @param id Id of the entity
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getReportSatisfactionQuizDetails(satisfactionQuizId: number, type: string, id: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<SatisfactionQuizDetailsResponse>;
    public getReportSatisfactionQuizDetails(satisfactionQuizId: number, type: string, id: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<SatisfactionQuizDetailsResponse>>;
    public getReportSatisfactionQuizDetails(satisfactionQuizId: number, type: string, id: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<SatisfactionQuizDetailsResponse>>;
    public getReportSatisfactionQuizDetails(satisfactionQuizId: number, type: string, id: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
        if (satisfactionQuizId === null || satisfactionQuizId === undefined) {
            throw new Error('Required parameter satisfactionQuizId was null or undefined when calling getReportSatisfactionQuizDetails.');
        }
        if (type === null || type === undefined) {
            throw new Error('Required parameter type was null or undefined when calling getReportSatisfactionQuizDetails.');
        }
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling getReportSatisfactionQuizDetails.');
        }

        let headers = this.defaultHeaders;

        let credential: string | undefined;
        // authentication (oauth) required
        credential = this.configuration.lookupCredential('oauth');
        if (credential) {
            headers = headers.set('Authorization', 'Bearer ' + credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.get<SatisfactionQuizDetailsResponse>(`${this.configuration.basePath}/reports/satisfaction-quizzes/${encodeURIComponent(String(satisfactionQuizId))}/${encodeURIComponent(String(type))}/${encodeURIComponent(String(id))}/details`,
            {
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get all report of satisfaction quizzes
     * @param page The page to load
     * @param startsAt filter by starts_at
     * @param endsAt filter by ends_at
     * @param course filter by course
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getReportSatisfactionQuizzes(page?: number, startsAt?: string, endsAt?: string, course?: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<ReportSatisfactionQuizzesResponse>;
    public getReportSatisfactionQuizzes(page?: number, startsAt?: string, endsAt?: string, course?: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<ReportSatisfactionQuizzesResponse>>;
    public getReportSatisfactionQuizzes(page?: number, startsAt?: string, endsAt?: string, course?: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<ReportSatisfactionQuizzesResponse>>;
    public getReportSatisfactionQuizzes(page?: number, startsAt?: string, endsAt?: string, course?: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {

        let queryParameters = new HttpParams({encoder: this.encoder});
        if (page !== undefined && page !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>page, 'page');
        }
        if (startsAt !== undefined && startsAt !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>startsAt, 'starts_at');
        }
        if (endsAt !== undefined && endsAt !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>endsAt, 'ends_at');
        }
        if (course !== undefined && course !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>course, 'course');
        }

        let headers = this.defaultHeaders;

        let credential: string | undefined;
        // authentication (oauth) required
        credential = this.configuration.lookupCredential('oauth');
        if (credential) {
            headers = headers.set('Authorization', 'Bearer ' + credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.get<ReportSatisfactionQuizzesResponse>(`${this.configuration.basePath}/reports/satisfaction-quizzes`,
            {
                params: queryParameters,
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Days of a specific user course report
     * @param userId The id of the user
     * @param courseId The id of the course
     * @param editionId The id of the edition
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getReportUserCourseEditionDays(userId: number, courseId: string, editionId: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<ReportUserCourseEditionDaysResponse>;
    public getReportUserCourseEditionDays(userId: number, courseId: string, editionId: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<ReportUserCourseEditionDaysResponse>>;
    public getReportUserCourseEditionDays(userId: number, courseId: string, editionId: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<ReportUserCourseEditionDaysResponse>>;
    public getReportUserCourseEditionDays(userId: number, courseId: string, editionId: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
        if (userId === null || userId === undefined) {
            throw new Error('Required parameter userId was null or undefined when calling getReportUserCourseEditionDays.');
        }
        if (courseId === null || courseId === undefined) {
            throw new Error('Required parameter courseId was null or undefined when calling getReportUserCourseEditionDays.');
        }
        if (editionId === null || editionId === undefined) {
            throw new Error('Required parameter editionId was null or undefined when calling getReportUserCourseEditionDays.');
        }

        let headers = this.defaultHeaders;

        let credential: string | undefined;
        // authentication (oauth) required
        credential = this.configuration.lookupCredential('oauth');
        if (credential) {
            headers = headers.set('Authorization', 'Bearer ' + credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.get<ReportUserCourseEditionDaysResponse>(`${this.configuration.basePath}/reports/courses/${encodeURIComponent(String(userId))}/courses/${encodeURIComponent(String(courseId))}/editions/${encodeURIComponent(String(editionId))}/days`,
            {
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Editions of a specific user course report
     * @param userId The id of the user
     * @param courseId The id of the course
     * @param year filter by year
     * @param status filter by status
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getReportUserCourseEditions(userId: number, courseId: string, year?: number, status?: ReportEditionstatus, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<ReportUserCourseEditionsResponse>;
    public getReportUserCourseEditions(userId: number, courseId: string, year?: number, status?: ReportEditionstatus, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<ReportUserCourseEditionsResponse>>;
    public getReportUserCourseEditions(userId: number, courseId: string, year?: number, status?: ReportEditionstatus, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<ReportUserCourseEditionsResponse>>;
    public getReportUserCourseEditions(userId: number, courseId: string, year?: number, status?: ReportEditionstatus, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
        if (userId === null || userId === undefined) {
            throw new Error('Required parameter userId was null or undefined when calling getReportUserCourseEditions.');
        }
        if (courseId === null || courseId === undefined) {
            throw new Error('Required parameter courseId was null or undefined when calling getReportUserCourseEditions.');
        }

        let queryParameters = new HttpParams({encoder: this.encoder});
        if (year !== undefined && year !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>year, 'year');
        }
        if (status !== undefined && status !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>status, 'status');
        }

        let headers = this.defaultHeaders;

        let credential: string | undefined;
        // authentication (oauth) required
        credential = this.configuration.lookupCredential('oauth');
        if (credential) {
            headers = headers.set('Authorization', 'Bearer ' + credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.get<ReportUserCourseEditionsResponse>(`${this.configuration.basePath}/reports/courses/${encodeURIComponent(String(userId))}/courses/${encodeURIComponent(String(courseId))}/editions`,
            {
                params: queryParameters,
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Courses of a specific user multicourse report
     * @param userId The id of the user
     * @param courseId The id of the course
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getReportUserMulticourseCourses(userId: number, courseId: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<ReportUserMulticourseCoursesResponse>;
    public getReportUserMulticourseCourses(userId: number, courseId: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<ReportUserMulticourseCoursesResponse>>;
    public getReportUserMulticourseCourses(userId: number, courseId: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<ReportUserMulticourseCoursesResponse>>;
    public getReportUserMulticourseCourses(userId: number, courseId: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
        if (userId === null || userId === undefined) {
            throw new Error('Required parameter userId was null or undefined when calling getReportUserMulticourseCourses.');
        }
        if (courseId === null || courseId === undefined) {
            throw new Error('Required parameter courseId was null or undefined when calling getReportUserMulticourseCourses.');
        }

        let headers = this.defaultHeaders;

        let credential: string | undefined;
        // authentication (oauth) required
        credential = this.configuration.lookupCredential('oauth');
        if (credential) {
            headers = headers.set('Authorization', 'Bearer ' + credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.get<ReportUserMulticourseCoursesResponse>(`${this.configuration.basePath}/reports/courses/${encodeURIComponent(String(userId))}/multicourses/${encodeURIComponent(String(courseId))}/courses`,
            {
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get etl certifications
     * @param code filter by code
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public listCertifications(code?: ReportCertificationCode, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<GlimpseResponse>;
    public listCertifications(code?: ReportCertificationCode, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<GlimpseResponse>>;
    public listCertifications(code?: ReportCertificationCode, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<GlimpseResponse>>;
    public listCertifications(code?: ReportCertificationCode, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {

        let queryParameters = new HttpParams({encoder: this.encoder});
        if (code !== undefined && code !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>code, 'code');
        }

        let headers = this.defaultHeaders;

        let credential: string | undefined;
        // authentication (oauth) required
        credential = this.configuration.lookupCredential('oauth');
        if (credential) {
            headers = headers.set('Authorization', 'Bearer ' + credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.get<GlimpseResponse>(`${this.configuration.basePath}/reports/certifications`,
            {
                params: queryParameters,
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get etl managers
     * @param userId filter by userId
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public managers(userId?: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<GlimpseResponse>;
    public managers(userId?: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<GlimpseResponse>>;
    public managers(userId?: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<GlimpseResponse>>;
    public managers(userId?: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {

        let queryParameters = new HttpParams({encoder: this.encoder});
        if (userId !== undefined && userId !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>userId, 'user_id');
        }

        let headers = this.defaultHeaders;

        let credential: string | undefined;
        // authentication (oauth) required
        credential = this.configuration.lookupCredential('oauth');
        if (credential) {
            headers = headers.set('Authorization', 'Bearer ' + credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.get<GlimpseResponse>(`${this.configuration.basePath}/reports/managers`,
            {
                params: queryParameters,
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get etl users roles
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public roles(observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<GlimpseResponse>;
    public roles(observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<GlimpseResponse>>;
    public roles(observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<GlimpseResponse>>;
    public roles(observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {

        let headers = this.defaultHeaders;

        let credential: string | undefined;
        // authentication (oauth) required
        credential = this.configuration.lookupCredential('oauth');
        if (credential) {
            headers = headers.set('Authorization', 'Bearer ' + credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.get<GlimpseResponse>(`${this.configuration.basePath}/reports/roles`,
            {
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get etl users segments
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public segments(observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<GlimpseResponse>;
    public segments(observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<GlimpseResponse>>;
    public segments(observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<GlimpseResponse>>;
    public segments(observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {

        let headers = this.defaultHeaders;

        let credential: string | undefined;
        // authentication (oauth) required
        credential = this.configuration.lookupCredential('oauth');
        if (credential) {
            headers = headers.set('Authorization', 'Bearer ' + credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.get<GlimpseResponse>(`${this.configuration.basePath}/reports/segments`,
            {
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Info for a specific user course report
     * @param userId The id of the user
     * @param courseId The id of the course
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public showReportUserCourseDetail(userId: number, courseId: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<ReportUserCourseResponse>;
    public showReportUserCourseDetail(userId: number, courseId: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<ReportUserCourseResponse>>;
    public showReportUserCourseDetail(userId: number, courseId: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<ReportUserCourseResponse>>;
    public showReportUserCourseDetail(userId: number, courseId: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
        if (userId === null || userId === undefined) {
            throw new Error('Required parameter userId was null or undefined when calling showReportUserCourseDetail.');
        }
        if (courseId === null || courseId === undefined) {
            throw new Error('Required parameter courseId was null or undefined when calling showReportUserCourseDetail.');
        }

        let headers = this.defaultHeaders;

        let credential: string | undefined;
        // authentication (oauth) required
        credential = this.configuration.lookupCredential('oauth');
        if (credential) {
            headers = headers.set('Authorization', 'Bearer ' + credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.get<ReportUserCourseResponse>(`${this.configuration.basePath}/reports/courses/${encodeURIComponent(String(userId))}/courses/${encodeURIComponent(String(courseId))}`,
            {
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Info for a specific user edition report
     * @param userId The id of the user
     * @param courseId The id of the course
     * @param editionId The id of the edition
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public showReportUserCourseEditionDetail(userId: number, courseId: string, editionId: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<ReportUserCourseEditionResponse>;
    public showReportUserCourseEditionDetail(userId: number, courseId: string, editionId: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<ReportUserCourseEditionResponse>>;
    public showReportUserCourseEditionDetail(userId: number, courseId: string, editionId: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<ReportUserCourseEditionResponse>>;
    public showReportUserCourseEditionDetail(userId: number, courseId: string, editionId: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
        if (userId === null || userId === undefined) {
            throw new Error('Required parameter userId was null or undefined when calling showReportUserCourseEditionDetail.');
        }
        if (courseId === null || courseId === undefined) {
            throw new Error('Required parameter courseId was null or undefined when calling showReportUserCourseEditionDetail.');
        }
        if (editionId === null || editionId === undefined) {
            throw new Error('Required parameter editionId was null or undefined when calling showReportUserCourseEditionDetail.');
        }

        let headers = this.defaultHeaders;

        let credential: string | undefined;
        // authentication (oauth) required
        credential = this.configuration.lookupCredential('oauth');
        if (credential) {
            headers = headers.set('Authorization', 'Bearer ' + credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.get<ReportUserCourseEditionResponse>(`${this.configuration.basePath}/reports/courses/${encodeURIComponent(String(userId))}/courses/${encodeURIComponent(String(courseId))}/editions/${encodeURIComponent(String(editionId))}`,
            {
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Info for a specific user multicourse report
     * @param userId The id of the user
     * @param courseId The id of the multicourse
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public showReportUserMulticourseDetail(userId: number, courseId: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<ReportUserMulticourseResponse>;
    public showReportUserMulticourseDetail(userId: number, courseId: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<ReportUserMulticourseResponse>>;
    public showReportUserMulticourseDetail(userId: number, courseId: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<ReportUserMulticourseResponse>>;
    public showReportUserMulticourseDetail(userId: number, courseId: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
        if (userId === null || userId === undefined) {
            throw new Error('Required parameter userId was null or undefined when calling showReportUserMulticourseDetail.');
        }
        if (courseId === null || courseId === undefined) {
            throw new Error('Required parameter courseId was null or undefined when calling showReportUserMulticourseDetail.');
        }

        let headers = this.defaultHeaders;

        let credential: string | undefined;
        // authentication (oauth) required
        credential = this.configuration.lookupCredential('oauth');
        if (credential) {
            headers = headers.set('Authorization', 'Bearer ' + credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.get<ReportUserMulticourseResponse>(`${this.configuration.basePath}/reports/courses/${encodeURIComponent(String(userId))}/multicourses/${encodeURIComponent(String(courseId))}`,
            {
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
